import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(frontend)/strim-na-zakaz/page.tsx");
